import { stripMessage } from "@/utils";

export default (value) => {
  return stripMessage(value || "");
};
